export default require('./Error').default
